var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"meet-list"},_vm._l((_vm.dataList),function(item){return _c('Replay',{key:item.id,staticStyle:{"margin-bottom":"16px"},attrs:{"data":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }